import prodConfig from "./configs/config.prod";
import stagingConfig from "./configs/config.staging";
import { Environment } from "./environment.interface";

// export const environment: Environment = prodConfig;

const getConfiguration = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (typeof process !== "undefined") {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return process.env.APP_ENV_PROFILE === "prod" ? prodConfig : stagingConfig;
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return window.env === "prod" ? prodConfig : stagingConfig;
  }
};

export const environment = getConfiguration();
